import ServicePageLayout from "./ServicePageLayout";

const BULLETS = [
  "Élagage et taille douce respectueux de l'arbre",
  "Démontage par section sur arbres difficiles d'accès",
  "Abattage sécurisé avec rétention si nécessaire",
  "Évacuation des branches et tronçonnage du bois",
  "Broyage sur place possible (paillage)",
  "Intervention assurée avec matériel pro",
];

const PROCESS = [
  { title: "Diagnostic", desc: "Visite sur place, évaluation des risques et du travail." },
  { title: "Devis détaillé", desc: "Tarif clair, planning, modalités d'évacuation." },
  { title: "Intervention", desc: "Sécurisation, élagage ou abattage, nettoyage final." },
];

export default function ElagageCreuse() {
  return (
    <ServicePageLayout
      slug="elagage-creuse"
      title="Élagage et abattage d'arbres en Creuse"
      seoTitle="Élagage & abattage d'arbres Creuse (23) | K'REUSE"
      seoDescription="Élagage et abattage sécurisés en Creuse (23). Taille douce, démontage, abattage avec évacuation. Devis gratuit — 07 80 54 11 15."
      badge="Élagage & abattage · Creuse"
      hero="Élagage de précision, taille douce ou abattage en sécurité : K'REUSE EXTÉRIEUR intervient sur tous types d'arbres en Creuse avec un équipement professionnel."
      intro="Que ce soit pour préserver la santé de vos arbres, sécuriser votre propriété ou abattre un sujet dangereux, nous intervenons avec rigueur et matériel adapté. Tronçonneuses, harnais et techniques d'élagage maîtrisées. Évacuation et broyage des déchets verts inclus."
      bullets={BULLETS}
      process={PROCESS}
      ctaTitle="Un arbre à élaguer ou abattre ?"
      ctaDesc="Devis gratuit sur place. Intervention rapide."
      image="/img/photos/elagage-arbre.webp"
      whatsappText="Bonjour, je souhaite un devis pour de l'élagage / abattage d'arbre."
    />
  );
}
